/* eslint-disable react/require-default-props */
import { Component } from 'react'
import { connect } from 'react-redux'
import { isUndefined, values } from 'lodash'
import PropTypes from 'prop-types'
import { settingsPath } from 'lib/urls'
import * as BLConstants from 'shared/constants'
import sha1 from 'crypto-js/sha1'
import { sentiments } from 'registry/constants'
import Image from 'components/image'
import { setCurrentUser } from 'shared/utils/setCurrentUser/setCurrentUser'
import { signup } from '../../../actions'
import {
  getSentiment,
  getUserEmail,
  getUserFullName,
  getUserId,
} from '../../../reducers'
import Slide, { Title } from '../../Slide/Slide'
import { NextButton } from '../../OnboardingButtons/OnboardingButtons'
import OneStepSignupForm from './OneStepSignupForm/OneStepSignupForm'
import css from './OneStepSignUpFlow.scss'
import withRouter from 'shared/HOC/withRouter'

const trackRegistryCreate = ({ registry, user }) => {
  if (!isUndefined(window.ire)) {
    ire(
      'trackConversion',
      25150,
      {
        orderId: registry.id,
        customerId: registry.id,
        customerEmail: sha1(user.email).toString(),
      },
      {
        verifySiteDefinitionMatch: true,
      }
    )
  }

  if (!isUndefined(window.ga)) {
    ga('send', {
      hitType: 'event', // required
      eventCategory: 'Registry', // required
      eventAction: 'create', // required
      eventValue: 0, // required
    })
  }

  // Remove the existing currentUser script tag (_js_current_user.html.erb)
  // and inject a new one so that it can be picked up by GoogleTagManager tracking.
  $('script#currentUser').remove()
  $('body').append(
    `<script id="currentUser">window.currentUser = ${JSON.stringify(
      user
    )}</script>`
  )
  setCurrentUser(user)

  // Facebook tracking
  fbq(
    'trackCustom',
    'RegistryCreated',
    {},
    { eventID: `registryCreated:${registry?.id}` }
  )

  // Yahoo tracking
  dotq.push({
    projectId: BLConstants.YAHOO_DOT_TAG_PROJECT_ID,
    properties: {
      pixelId: BLConstants.YAHOO_DOT_TAG_PIXEL_ID,
      qstrings: {
        et: 'custom',
        ec: 'registry',
        ea: 'create',
      },
    },
  })
}

export class OneStepSignUpFlow extends Component {
  constructor(props) {
    super(props)
    // Do not immediately transition to the disabled signup form after signup.
    // Instead, only show this state when going back or opening for the first time.
    this.state = {
      alreadySignedUp: props.signedUp,
    }
  }

  title = () => (
    // eslint-disable-next-line react/destructuring-assignment
    <p>
      We're the baby registry that lets you add{' '}
      <span className={css.squiggleUnderline}>
        {' '}
        anything <div className={css.squiggleUnderlineDiv} />
      </span>{' '}
      you could possibly want.
    </p>
  )

  // eslint-disable-next-line react/destructuring-assignment,react/prop-types
  goToNext = () => this.props.router.navigate(this.props.nextPath)

  onSubmitSuccess = (result) => {
    trackRegistryCreate(result)
    this.goToNext()
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    const signedUp = this.state.alreadySignedUp
    // eslint-disable-next-line react/prop-types
    const { email, name, signup, nextPath } = this.props
    const password = signedUp ? '****************' : null

    return (
      <Slide>
        <Image
          className={css.logoImage}
          src="https://images.babylist.com/image/upload/v1688956176/WELCOME_tgchbe.svg"
        />
        <Title className={css.titleSection}>{this.title()}</Title>
        <OneStepSignupForm
          initialValues={{ name, email, password }}
          signedUp={signedUp}
          onSubmit={signup}
          onSubmitSuccess={this.onSubmitSuccess}
        />
        {signedUp ? (
          <div>
            <p className="text-center small mbl">
              You're signed up!
              <br />
              You can update your name, email and password in{' '}
              <a href={settingsPath}>Settings</a>.
            </p>
            {/* eslint-disable-next-line react/destructuring-assignment */}
            <NextButton to={nextPath} />
          </div>
        ) : null}
      </Slide>
    )
  }
}

OneStepSignUpFlow.propTypes = {
  // eslint-disable-next-line react/require-default-props
  email: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  name: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  signedUp: PropTypes.bool.isRequired,
  nextPath: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
  email: getUserEmail(state),
  name: getUserFullName(state),
  sentiment: getSentiment(state),
  signedUp: !!getUserId(state),
})

// eslint-disable-next-line import/no-default-export
export default withRouter(
  connect(mapStateToProps, { signup })(OneStepSignUpFlow)
)
